import React from 'react';

import { listTargetPropTypes, reorderableListTarget } from "helpers/react_dnd/reorderable_list";

class SectionDropzone extends React.Component {
  static propTypes = {
    ...listTargetPropTypes
  };

  render() {
    return this.props.connectDropTarget(
      <div className="section-dropzone">
        {this.props.children}
      </div>
    );
  }
}

export default reorderableListTarget(SectionDropzone, 'websiteSection', {});
